import { stringify } from 'query-string';
import { apiFetch } from './utils';

export const illiquidCashflow = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };

    const query = stringify(args, { arrayFormat: 'comma' });

    const url = `/v3/illiquid-cashflow?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
